/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_StopInputs */

const en_mk_team_control_stop = /** @type {(inputs: Mk_Team_Control_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop and continue with clear ownership`)
};

const id_mk_team_control_stop = /** @type {(inputs: Mk_Team_Control_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti dan lanjutkan dengan jelas`)
};

/**
* | output |
* | --- |
* | "Stop and continue with clear ownership" |
*
* @param {Mk_Team_Control_StopInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_stop = /** @type {((inputs?: Mk_Team_Control_StopInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_StopInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_stop(inputs)
	return en_mk_team_control_stop(inputs)
});